export default "__VITE_ASSET__BXOeFtai__"